// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__2Z1L0","radius-30":"Card_radius-30__gQe6z","radius-20":"Card_radius-20__hL1iq","radius-10":"Card_radius-10__2X94C"};